// DbDrawer.styles.ts
import { StyleSheet } from 'react-native';

export const styles = StyleSheet.create({
    // 遮罩层：优化背景色过渡，避免突兀
    overlay: {
        flex: 1,
        backgroundColor: 'rgba(0, 0, 0, 0.5)', // 适中的透明度，过渡更自然
        position: 'absolute',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
    },
    drawer: {
        width: 280,
        height: '100%',
        backgroundColor: '#fff',
        elevation: 8,
        shadowColor: '#000',
        shadowOpacity: 0.2,
        shadowRadius: 4,
        shadowOffset: { width: 2, height: 0 },
        position: 'absolute',
        top: 0,
        left: 0,
    },
    drawerRight: {
        left: undefined,
        right: 0,
    },
});
